import { inject, Injectable } from "@angular/core";
import { ConfigService } from "./config.service";

@Injectable()
export class DateService {

    public days: string[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    constructor(public configService: ConfigService) {

    }

    getNewDate(inputDate: string): Date {
        const dateTime = inputDate.split('T');
        const dates = dateTime[0].split('-');
        const times = dateTime[1].split(':');

        const year: number = +dates[0];
        const month: number = +dates[1];
        const day: number = +dates[2];

        const hour: number = +times[0];
        const minute: number = +times[1];
        const second: number = +times[2];

        return new Date(year, month - 1, day, hour, minute, second);
    }

    formatTime(date: Date): string {
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12;
        const strMinutes = minutes >= 10 ? minutes : '0' + minutes;
        const strHours = hours >= 10 ? hours : '0' + hours;
        const strTime = strHours + ':' + strMinutes + ' ' + ampm;
        return strTime;
    }

    formatHour(date: Date): number {
        let hours = date.getHours();
        hours = hours % 12;
        hours = hours ? hours : 12;
        const strHours = hours >= 10 ? hours : 0 + hours;
        return hours;
    }

    formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();

        const strMinutes = minutes >= 10 ? minutes : '0' + minutes;
        const strHours = hours >= 10 ? hours : '0' + hours;
        const strMonths = month >= 10 ? month : '0' + month;
        const strDays = day >= 10 ? day : '0' + day;

        const strTime = year + '-' + strMonths + '-' + strDays;
        return strTime;
    }

    formatDateTime(date: Date): string {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();

        const strMinutes = minutes >= 10 ? minutes : '0' + minutes;
        const strHours = hours >= 10 ? hours : '0' + hours;
        const strMonths = month >= 10 ? month : '0' + month;
        const strDays = day >= 10 ? day : '0' + day;

        const strTime = year + '-' + strMonths + '-' + strDays + 'T' + strHours + ':' + strMinutes + ':00';
        return strTime;
    }

    getDay(date: Date): string {
        return this.days[date.getDay() - 1];
    }

    addDays(date, days): Date {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}